import React from 'react'
import cn from 'classnames'
import { useS4LContext } from '@s4l/react-context'

import { IconText, Typography } from '@s4l/ds'

import styles from './styles.module.css'

interface IRequestMessage {
  children?: string | React.ReactElement
  icon: React.ComponentType<{ className?: string; size?: string | number }>
  hasBackground?: boolean
  title?: string
}

function RequestMessage({ children, icon: Icon, hasBackground, title }: Readonly<IRequestMessage>) {
  const { i18n } = useS4LContext()

  const baseClassName = cn(styles.container, {
    [styles.withBackground]: hasBackground,
  })

  return (
    <div className={baseClassName}>
      <IconText className="mb-8" size="xl" icon={<Icon className={styles.icon} size="24" />}>
        {title}
      </IconText>
      <Typography size="l">
        {children || i18n.formatMessage({ id: 'room.special-requests-confirmation' })}
      </Typography>
    </div>
  )
}

RequestMessage.displayName = 'RequestMessage'

export default RequestMessage
